module.exports = __webpack_public_path__ + "media/map_bg.fdc25513.mp3";